<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
                <div class="">
                    <v-row justify="center" >
                        <v-col class="text-center col-md-5 col-lg-5">
                            <div class="font-weight-bold body-1">
                                Registar nueva empresa
                            </div>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12" md="5" lg="5">
                            <v-form ref="form" @submit.prevent="save">
                                <business-form ref="BusinessForm" :values="form" @save="save" :serverErrors="serverErrors"></business-form>
                            </v-form>
                        </v-col>
                        
                    </v-row>
                </div>
                
                <v-row justify="center" align="end" class="">
                    <v-col cols="12" md="5" lg="5" class="">
                        <v-row justify="end" class="px-3 py-3">
                            <secondary-button :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                            <primary-button :props="saveBtnData" class=""></primary-button>  
                        </v-row>
                    </v-col>
                </v-row>
        </template>
    </contentCard>
</template>

<script>
import Utils from '../../../helpers/Utils';
import BusinessForm from "./Form.vue";
import Object2Form from "../../../helpers/Object2Form";
export default {
    components: {
        'business-form': BusinessForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            form: {
                name: "",
                trade_name: "",
                entry: "",
                rfc: "",
                logo_file: [],
                logo_path: "",

                address:"",
                neighborhood:"",
                city:"",
                state:"",
                country:"",
                zip_code:"",
                email:"",
                phone:"",
                menu:null,
                fiscal_regime:"",
                self_billing: 0,
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Business",
                block:false,	
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
    },
	methods: {
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
        save(){
            
            //console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.business.store(form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha creado correctamente`);
                        this.$router.push({name: 'Business'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("error" in error.response.data)){
                                    if(error.response.data.error instanceof Object){
                                        Object.keys(error.response.data.error).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.error;
                                            error.response.data.error[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.error)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario inválido`);
            }
            // eslint-disable-next-line no-console
        },

        prepareRequest(request)
        {
            let data = JSON.parse(JSON.stringify(request));

            data.menu = JSON.stringify(request.menu??{})

            data.logo_file = request.logo_file;

            data.self_billing =  data.self_billing == true ? 1 : 0;

            return Object2Form.objectToFormData(data, "", []);
        }
    },
}
</script>
